import React, { useState, useEffect } from 'react';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { Routes } from './routes';
import { config } from '@uhg-abyss/web/tools/config';

// import { Path, To, createHashHistory } from 'history';
// import { unstable_HistoryRouter as HistoryRouter } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
// import { RouterProvider } from '@uhg-abyss/web/ui/RouterProvider';
import { HashRouter } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { AppProvider, LagoonContext } from './AppContext';
import { registerAnalytics } from '@src/tools/analytics';
import { Provider } from 'react-redux';
import { store } from '@src/store';

const theme = createTheme('uhc', {
  enterpriseFont: true,
  css: {
    '.abyss-nav-menu-viewport': {
      overflow: 'visible',
    },
    '.abyss-nav-menu-viewport .abyss-nav-menu-menu-item': {
      overflow: 'auto',
      height: 'auto', // adjust as needed
    },
  },
});
const { lagoon } = require('@uhg-lagoon/sdk');

const env = config('APP_ENV');

// const patchHashHistory = (history: any) => {
//   return {
//     ...history,
//     createURL: (location: To) => {
//       const base = document.baseURI || window.location.origin;
//       return `${base}#${history.createHref(location)}`;
//     },
//     encodeLocation: (location: Path) => {
//       return {
//         ...location,
//         pathname: encodeURI(location.pathname),
//         search: encodeURI(location.search),
//         hash: encodeURI(location.hash),
//       };
//     },
//   };
// };

export const browser = () => {
  const [lagoonInitialized, setLagoonInitialized] = useState(false);

  useEffect(() => {
    registerAnalytics();

    // Initialize Lagoon SDK
    const initializeLagoon = async () => {
      try {
        const schema = {
          loadTables: true,
          loadForms: false,
          autoRefresh: true,
          refreshInterval: 600,
        };
        const proxyOptions = {
          baseUrl: config('CORE_LAGOON_PROXY_BASE_URL'),
        };

        await lagoon.initialize(config('LAGOON_NAMESPACE'), env, {
          ...schema,
          ...(config('CORE_PROXY_TOGGLE') && { proxyOptions }),
        });
        setLagoonInitialized(true);
      } catch (error) {
        console.error('Lagoon initialization failed:', error);
        // Continue loading the app even if Lagoon initialization fails
        setLagoonInitialized(false);
      }
    };

    initializeLagoon();

    if (window.location.pathname === '/' && !window.location.hash) {
      window.location.replace(`${window.location.origin}/#/`);
    }
  }, []);

  // const patchedHistory = patchHashHistory(createHashHistory());
  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <LagoonContext.Provider value={lagoonInitialized ? lagoon : null}>
          <Provider store={store}>
            <AppProvider>
              <Routes />
            </AppProvider>
          </Provider>
        </LagoonContext.Provider>
      </HashRouter>
    </ThemeProvider>
  );
};
